import { changePassword, createUserSystem, deleteUserSystem, getAuthProfile, getUserRoleWithoutAdmin, getUserSystem, requestAuthLoginPassword, requestKeepAlive, updateFactory, updateUserProfile, updateUserSystem } from 'services/authAPI';
import { UseMutationResult, useMutation, UseQueryResult, useQuery } from '@tanstack/react-query';
import {
    AuthProfileResponse,
    ChangePasswordInput,
    ChangePasswordResponse,
    CreateUserSystemInput,
    CreateUserSystemResponse,
    DeleteUserSystemInput,
    InputUpdateFactory,
    InputUpdateUserProfile,
    KeepAliveInput,
    LoginPasswordInput,
    LoginPasswordResponse,
    RequestOPTAuthInput,
    ResponseKeepAlive,
    ResponseRequestAuthOTP,
    ResponseSubmitAuthOTP,
    SubmitOTPAuthInput,
    UpdateFactoryResponse,
    UpdateUserProfileResponse,
    UpdateUserSystemInput,
    UserRoleWithoutAdminResponse,
    UserSystemInput,
    UserSystemResponse,
} from 'services/interface'
import { requestAuthRequestOtp, requestAuthLogin } from 'services/authAPI'

export const useRequestAuthOtp = (): UseMutationResult<
  ResponseRequestAuthOTP,
  Error,
  RequestOPTAuthInput,
  unknown
> => {
  return useMutation<ResponseRequestAuthOTP, Error, RequestOPTAuthInput, unknown>({
    mutationFn: (input: RequestOPTAuthInput): Promise<ResponseRequestAuthOTP> => requestAuthRequestOtp(input),
  })
}

export const useSubmitAuthOtp = (): UseMutationResult<
  ResponseSubmitAuthOTP,
  Error,
  SubmitOTPAuthInput,
  unknown
> => {
  return useMutation<ResponseSubmitAuthOTP, Error, SubmitOTPAuthInput, unknown>({
    mutationFn: (input: SubmitOTPAuthInput): Promise<ResponseSubmitAuthOTP> => requestAuthLogin(input),
  })
}

export const useLoginPassword = (): UseMutationResult<
  LoginPasswordResponse,
  Error,
  LoginPasswordInput,
  unknown
> => {
  return useMutation<LoginPasswordResponse, Error, LoginPasswordInput, unknown>({
    mutationFn: (input: LoginPasswordInput): Promise<LoginPasswordResponse> => requestAuthLoginPassword(input),
  })
}

export const useChangePassword = (): UseMutationResult<
  ChangePasswordResponse,
  Error,
  ChangePasswordInput,
  unknown
> => {
  return useMutation<ChangePasswordResponse, Error, ChangePasswordInput, unknown>({
    mutationFn: (input: ChangePasswordInput): Promise<ChangePasswordResponse> => changePassword(input),
  })
}

export const useGetAuthProfile = (): UseQueryResult<AuthProfileResponse, Error> => {
    return useQuery<AuthProfileResponse, Error>({
      queryKey: ['profile'],
      queryFn: () => getAuthProfile(),
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    })
  }

  export const useRequestKeepAlive = (): UseMutationResult<
  ResponseKeepAlive,
  Error,
  KeepAliveInput,
  unknown
> => {
  return useMutation<ResponseKeepAlive, Error, KeepAliveInput, unknown>({
    mutationFn: (input: KeepAliveInput): Promise<ResponseKeepAlive> => requestKeepAlive(input),
  })
}

export const useUpdateFactory = (): UseMutationResult<
  UpdateFactoryResponse,
  Error,
  InputUpdateFactory,
  unknown
> => {
  return useMutation<UpdateFactoryResponse, Error, InputUpdateFactory, unknown>({
    mutationFn: (input: InputUpdateFactory): Promise<UpdateFactoryResponse> => updateFactory(input),
  })
}

export const useUserUpdateProfile = (): UseMutationResult<
  UpdateUserProfileResponse,
  Error,
  InputUpdateUserProfile,
  unknown
> => {
  return useMutation<UpdateUserProfileResponse, Error, InputUpdateUserProfile, unknown>({
    mutationFn: (input: InputUpdateUserProfile): Promise<UpdateUserProfileResponse> => updateUserProfile(input),
  })
}


export const useGetUserRoleWithoutAdmin = (): UseQueryResult<UserRoleWithoutAdminResponse, Error> => {
    return useQuery<UserRoleWithoutAdminResponse, Error>({
      queryKey: ['profile'],
      queryFn: () => getUserRoleWithoutAdmin(),
      staleTime: 1000 * 60 * 60 * 24, // 24 hours
    })
  }
  
  
  
  export const useGetUserSystem = (input: UserSystemInput): UseQueryResult<UserSystemResponse, Error> => {
    return useQuery<UserSystemResponse, Error>({
      queryKey: ['user_system', input],
      queryFn: () => getUserSystem(input),
      staleTime: 1000 * 60 * 60 * 24, // Uncomment if you need to set staleTime
    })
  }
  
  export const useCreateUserSystem = (): UseMutationResult<
    CreateUserSystemResponse,
    Error,
    CreateUserSystemInput,
    unknown
  > => {
    return useMutation<CreateUserSystemResponse, Error, CreateUserSystemInput, unknown>({
      mutationFn: (input: CreateUserSystemInput): Promise<CreateUserSystemResponse> => createUserSystem(input),
    })
  }
  
  export const useDeleteUserSystem = (): UseMutationResult<
    CreateUserSystemResponse,
    Error,
    DeleteUserSystemInput,
    unknown
  > => {
    return useMutation<CreateUserSystemResponse, Error, DeleteUserSystemInput, unknown>({
      mutationFn: (input: DeleteUserSystemInput): Promise<CreateUserSystemResponse> => deleteUserSystem(input),
    })
  }
  
  export const useUpdateUserSystem = (): UseMutationResult<
    CreateUserSystemResponse,
    Error,
    UpdateUserSystemInput,
    unknown
  > => {
    return useMutation<CreateUserSystemResponse, Error, UpdateUserSystemInput, unknown>({
      mutationFn: (input: UpdateUserSystemInput): Promise<CreateUserSystemResponse> => updateUserSystem(input),
    })
  }

  